<div class="main-content">
  <div class="container-fluid">
    <!-- <button class="btn" (click)="AddModuel()">Add Module</button> -->
    <div class="row">
      <ng-container *ngFor="let item of clientmodule; let i = index">
        <!-- Make the column responsive with col-12 for mobile, col-6 for tablets, and col-4 for desktop -->
        <div class="col-12 col-sm-6 col-md-4 curserPointer" (click)="onCardClick(item)">
          <div class="text-center">
            <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" width="200" height="300">
              <defs>
              
                     <image width="155" height="140" [id]="item.name" [attr.href]="item.image" />
                   
              </defs>
              <style>
                .color {
                  fill: #f0552f

                }
                  /* Keyframe animation to make paths appear one by one */
                  @keyframes show {
                    0% {
                      opacity: 0;
                    }
                    100% {
                      opacity: 1;
                    }
                    
                  }
              
                  /* Apply animation to each path */
                  path {
                    opacity: 0; /* Start hidden */
                    animation: show 0.1s ease-in-out forwards; /* Each path fades in and stays visible after animation */
                }
                  /* Stagger the animation delays for each path */
                  .a {
                    animation-delay: 0.1s;
                  }
              
                  .b {
                    animation-delay: 0.2s;
                  }
              
                  .c {
                    animation-delay: 0.3;
                  }
              
                  .d {
                    animation-delay: 0.4s;
                  }
              
                  .e {
                    animation-delay: 0.5s;
                  }
              </style>

                
              <use  [attr.href]="'#' + item.name"  class="d" transform="matrix(.835,0,0,.835,50,120)" />
              <path fill-rule="evenodd" class="a color" d="m124.3 272.4l25.5 25.6 45-44.9-25.6-25.6z" />
              <path fill-rule="evenodd" class="b color" d="m293.7 143.8l-143.9-143.8-143.8 143.8h51.1l92.7-92.7 92.7 92.7z" />
              <path fill-rule="evenodd" class="c color" d="m242.5 154.2l-66.6 66.6 25.6 25.6 92.2-92.2z" />
            </svg>
            <div class="text-center">          
                  <ng-container class="col-12"  *ngFor="let word of item.Words; let i = index">
                <span class="text-center modulename" [ngStyle]="{'color': word.color}">{{ word.word }}</span>&nbsp;
              </ng-container>
</div>
            <!-- <div   class="text-center modulename" [innerHTML]="getStyledSentence(item.name)"></div> -->
          </div>


 



        </div>
      </ng-container>
    </div>
  </div>
</div>